'use client';

import { createUsersApi } from '../../modules/users';
import { useEnterApiDomain } from '../use-enter-api-domain';

/** 获取按当前 Provider 传输依赖创建的 users 领域客户端。 */
export function useUsersApi() {
    return useEnterApiDomain(createUsersApi);
}
